import { ProductsByIdsQuery } from "@chef/state-management";

type NutritionFacts =
  | ProductsByIdsQuery["products"][number]["variations"][number]["contents"]["nutritionFacts"];

export const groupNutritionFactsByIngridient = (facts?: NutritionFacts) => {
  if (!facts) {
    return [];
  }

  const groupedFacts = [...facts]
    .sort((a, b) => a.name.localeCompare(b.name))
    .reduce(
      (acc, fact) => {
        if (!fact.ingredientName) {
          acc["default"].push(fact);
        } else if (!acc[fact.ingredientName]) {
          acc[fact.ingredientName] = [fact];
        } else {
          acc[fact.ingredientName].push(fact);
        }

        return acc;
      },
      { default: [] } as Record<string, NutritionFacts>,
    );

  return Object.entries(groupedFacts);
};
